import { Module } from "vuex";
import { RootState } from "@/store/types";
import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";
import { AuditsState } from "./types";
import { MutationsType, GettersType, ActionsType } from "@/utils/VuexHelper";

const state = new AuditsState();

const namespaced: boolean = true;
const modul: Module<AuditsState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};

export const api = {
  namespace: "audits",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};

export type Mutations = MutationsType<typeof mutations>;
export type Getters = GettersType<typeof getters>;
export type Actions = ActionsType<typeof actions>;

export default modul;
